import { ApplicationStatus, LockOwner } from 'graphql/__generated__/graphql';

export const getStatusDisplay = (applicationStatus: ApplicationStatus, lockedBy: LockOwner) => {
    switch (applicationStatus) {
        case ApplicationStatus.InProgress: {
            switch (lockedBy) {
                case LockOwner.Applicant:
                    return 'In Progress';
                case LockOwner.Emdr:
                    return 'Awaiting EMDR review';
                case LockOwner.Supervisor:
                    return 'Awaiting supervisor review';
                default:
                    return 'Status unknown';
            }
        }
        case ApplicationStatus.ReadyForReview:
            return 'Ready for supervisor review';
        case ApplicationStatus.ReadyToSubmit:
            return 'Reviews complete';
        case ApplicationStatus.NeedsWork:
            return 'One or more items need your attention';
        case ApplicationStatus.Approved:
            return 'Approved';
        default:
            return 'Status unknown';
    }
};

export const getBadgeClass = (lockedBy?: LockOwner, status?: ApplicationStatus): string => {
    if (!lockedBy || !status) return '';
    return `app-status-${lockedBy.toLowerCase()}-${status.toLowerCase().replaceAll('_', '-')}`;
};
